import * as z from "zod";

export const OTP_TIME_LIMIT = 45;

export const PASSWORD_REGEX =
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,16}$/;

export const phoneNumberSchema = z
  .string()
  .regex(/^(\+\d{1,3}[- ]?)?\d{10}$/, "Invalid number format");

export const emailSchema = z.string().email({ message: "Invalid email address" });

export const MENTION_REGEX = /<span.*?data-id="([a-zA-Z0-9._]+)".*?>.*?<\/span>/g;

export const UL_APP_VERSION_CHECK_INTERVAL = 90000; // 90sec
export const UL_APP_VERSION_CHECK_URL = "/meta.json";

export const DEFAULT_VALUES_STORAGE_PREFIX = "ul_defaultValues:";
export const STATIC_VALUES_STORAGE_PREFIX = "ul_staticValues:";
export const DEFAULT_TOAST_VISIBILITY_DURATION = 2000; // 2sec
export const DEFAULT_TOAST_DELAY = 300;

export const DEFAULT_INLINE_FORM_SWITCH_DURATION = 300;
export const DEFAULT_HIDE_FORM_SUCESS_DIALOG_DURATION = 2000;
export const DEFAULT_SWICTH_SIGNIN_AFTER_ORG_CREATION_DURATION = 2000;

export const DEFAULT_CONTEXT_MENU_TIMER = 300;

export const SCROLL_BY_AMOUNT = 300;

export const enum ErrorMessages {
  FORM_NOT_FOUND = "Form Not Found",
  FORM_UNPUBLISHED = "Form Not Published",
}

export const ALL_RECORDS = "All Records";
